import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "flex flex-col items-center gap-2 text-center",
    "data-testid": "delete-contact-permission-denied-body"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "text-base leading-6 text-(--text-text-body) dark:text-(--text-text-white-default)" };
import { nextTick, ref, useId, watch } from "vue";
import { Button, IconShape, Modal } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactDeletePermissionDeniedModal',
    props: {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    },
    emits: ["update:modelValue"],
    setup(__props) {
        /**
         * Path D (OP-7215) — the "Supprimer" action stays visible to every user (per AC); the permission
         * check happens client-side (canEditOphub) the moment they click it, before any preview fetch.
         * A dedicated informational modal with a single "Fermer" replaces the usual disabled-button +
         * tooltip pattern here because the ticket calls for an explicit blocking message, not a greyed
         * out control.
         */
        const open = _useModel(__props, "modelValue");
        const titleId = useId();
        const closeButtonRef = ref(null);
        // Destructive-action safety (OP-6527 AC): focus lands on "Fermer" on open, not the Modal's own
        // header close icon. nextTick() wins the race against Modal's rAF-deferred autofocus fallback.
        watch(open, async (isOpen) => {
            if (!isOpen)
                return;
            await nextTick();
            closeButtonRef.value?.$el?.focus();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((open).value = $event)),
                size: "xs",
                "show-header": false,
                "footer-position": "center",
                "aria-labelledby": _unref(titleId)
            }, {
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        ref_key: "closeButtonRef",
                        ref: closeButtonRef,
                        variant: "secondary",
                        size: "md",
                        label: _ctx.$t('contact.detail.deleteContact.permissionDenied.close'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (open.value = false))
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(IconShape), {
                            size: "md",
                            color: "error",
                            variant: "outlined",
                            icon: "ri-error-warning-line"
                        }),
                        _createElementVNode("h2", {
                            id: _unref(titleId),
                            class: "text-xl font-bold text-(--text-text-black-default) dark:text-(--text-text-white-default) leading-6"
                        }, _toDisplayString(_ctx.$t("contact.detail.deleteContact.permissionDenied.title")), 9 /* TEXT, PROPS */, _hoisted_2),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("contact.detail.deleteContact.permissionDenied.subtitle")), 1 /* TEXT */)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "aria-labelledby"]));
        };
    }
});
